import { render, staticRenderFns } from "./DataBuildForInsectPests.vue?vue&type=template&id=cd91aea0&scoped=true&"
import script from "./DataBuildForInsectPests.vue?vue&type=script&lang=js&"
export * from "./DataBuildForInsectPests.vue?vue&type=script&lang=js&"
import style0 from "./DataBuildForInsectPests.vue?vue&type=style&index=0&id=cd91aea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd91aea0",
  null
  
)

export default component.exports